
import * as Enums from '../enums/index.js';
import BaseballResultsProcessor from '../entities/BaseballResultsProcessor.js';
import UniqueParametersForPitchAndHitProvider from './UniqueParametersForPitchAndHitProvider.js';
import FilteredBattingResultsProvider from './FilteredBattingResultsProvider.js';

class ResultPairsProvider {
    constructor(filteredBattingResultsProvider, customResultsProcessor) {
        this.resultsProcessor = customResultsProcessor || new BaseballResultsProcessor();
        this.filteredBattingResultsProvider = filteredBattingResultsProvider || new FilteredBattingResultsProvider(this.resultsProcessor);

        if (!(this.resultsProcessor instanceof BaseballResultsProcessor)) {
            throw new TypeError('customResultsProcessor must be an instance inheriting from BaseballResultsProcessor class');
        }

        if (!(this.filteredBattingResultsProvider instanceof FilteredBattingResultsProvider)) {
            throw new TypeError('filteredBattingResultsProvider must be an instance inheriting from FilteredBattingResultsProvider class');
        }
    }

    defaultFilters() {
        return this.filteredBattingResultsProvider.defaultFilters();
    }

    matchPairs (
        results,
        {
            // tagging context
            pitcherIds, pitcherHandedness, pitchResults, pitchTypes, pitchSet, batterIds, batterHandedness, zones,
            // scoring context
            outs, balls, strikes, runnersOn,
            // date time filtering
            dateFrom, dateTo,
            // session context - todo
        } = {}
    ) {
        const filteredPairs = this.filteredBattingResultsProvider.filterResults(results, {
            // tagging context
            pitcherIds, pitcherHandedness, pitchResults, pitchTypes, pitchSet, batterIds, batterHandedness, zones,
            // scoring context
            outs, balls, strikes, runnersOn,
            // date time filtering
            dateFrom, dateTo,
        });

        return filteredPairs;
    };

    listUniqueParametersForHittingSummary(
        results, {
            // tagging context
            pitcherIds, pitcherHandedness, pitchResults, pitchTypes, pitchSet, batterIds, batterHandedness, zones,
            // scoring context
            outs, balls, strikes, runnersOn,
            // date time filtering
            dateFrom, dateTo,
        } = {},
        pitchParameters, hitParameters, pitchToHitParamsToMerge, combinedPitchResult
    ) {
        pitchParameters = pitchParameters || [
            // tagging context
            [Enums.ResultData.BatterTagId.key],
            [Enums.ResultData.TagId.key],
            Enums.ResultData.getDataPath(Enums.PitchData.SwingHandedness.key),
            Enums.ResultData.getDataPath(Enums.PitchData.Result.key),
            Enums.ResultData.getDataPath(Enums.PitchData.Classification.key),
            //Enums.ResultData.getDataPath(Enums.PitchData.Mechanics.key),
            Enums.ResultData.getDataPath(Enums.PitchData.Handedness.key),
            // scoring context
            Enums.ResultData.getDataPath(Enums.PitchData.BeforePlayOuts.key),
            Enums.ResultData.getDataPath(Enums.PitchData.BeforePlayBalls.key),
            Enums.ResultData.getDataPath(Enums.PitchData.BeforePlayStrikes.key),
            Enums.ResultData.getDataPath(Enums.PitchData.BeforePlayRunnersOn.key),
        ];

        hitParameters = hitParameters || [
            [Enums.ResultData.TagId.key],
            Enums.ResultData.getDataPath(Enums.HitData.SwingHandedness.key),
            // Enums.ResultData.getDataPath(Enums.PitchData.Handedness.key), // right now we can't use it
        ];

        // it contains map between pitchParameters and hitParameters, so basically n item from pitchParameters will be merged with item from hitParameters at index equal to value at n
        pitchToHitParamsToMerge = pitchToHitParamsToMerge || [
            0, undefined, 1
        ];

        const filteredPairs = this.filteredBattingResultsProvider.filterResults(results, {
            // tagging context
            pitcherIds, pitcherHandedness, pitchResults, pitchTypes, pitchSet, batterIds, batterHandedness, zones,
            // scoring context
            outs, balls, strikes, runnersOn,
            // date time filtering
            dateFrom, dateTo,
        });

        const filteredPitches = this.filteredBattingResultsProvider.extractPitches(filteredPairs);
        const filteredHits = this.filteredBattingResultsProvider.extractHits(filteredPairs);
        
        return UniqueParametersForPitchAndHitProvider(
            pitchParameters, hitParameters, pitchToHitParamsToMerge, filteredPitches, filteredHits, this.resultsProcessor, combinedPitchResult
        );
    }
}

export default ResultPairsProvider;